import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { HelmetDatoCms } from 'gatsby-source-datocms'

import './index.css'
import './app.css'

const TemplateWrapper = ({ children, data }) => {
    return (
        <div>
            <Helmet
                title={data.datoCmsSite.globalSeo.fallbackSeo.title}
                meta={[
                    { name: 'description', content: data.datoCmsSite.globalSeo.fallbackSeo.description},
                    // { name: 'keywords', content: 'architecture, portfolio, contact, anva' }
                ]}
            />
            <HelmetDatoCms favicon={data.datoCmsSite.faviconMetaTags} />
            <div className="layout-container">
                {children()}
            </div>
        </div>
    )
}

TemplateWrapper.propTypes = {
    children: PropTypes.func,
}

export default TemplateWrapper

export const query = graphql`
    query LayoutQuery {
        datoCmsSite {
            faviconMetaTags {
                ...GatsbyDatoCmsFaviconMetaTags
            }
            globalSeo {
                siteName
            	fallbackSeo {
            	  title
            	  description
            	}
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js